/**
 * `/password-renewal` : URL utilisée par l'app mobile (`embedded=mobileapp` ou
 * `embedded=genericmobileapp`) pour ouvrir directement l'écran de renouvellement
 * forcé du mot de passe, avec son propre `token` (auto-login) plutôt que via une
 * session web déjà établie.
 *
 * Sans cette route, l'URL ne correspond à aucune route connue et tombe dans le
 * `redirect: '/'` générique de `src/router/routes/index.js`, qui perd le contexte
 * "renouvellement forcé" : l'utilisateur finit sur `home`, pas sur l'écran de
 * changement de mot de passe attendu par l'app mobile.
 *
 * On redirige donc explicitement vers `profile-password` en forçant `forced=true`
 * et en conservant le reste de la query (`embedded`, `darkMode`, `token`...) :
 * `AutoLoginNavigationGuard` s'authentifie alors avec `token`, puis
 * `ForcedPasswordRenewalNavigationGuard`/`PasswordExpirationNavigationGuard`
 * laissent passer grâce à `embedded`, exactement comme pour
 * `profile-password?forced=true&embedded=mobileapp`.
 */
export default [
	{
		name: 'password-renewal',
		path: 'password-renewal',
		redirect: to => ({
			name: 'profile-password',
			query: {
				...to.query,
				forced: 'true'
			}
		})
	}
]
